import React from 'react';
import cs from 'classnames';
import times from 'lodash/times';
import { widgetCarouselDotsDataHooks } from './WidgetCarouselDots.dataHooks';
import styles from './WidgetCarouselDots.scss';

interface WidgetCarouselDotsProps {
  dotsCount: number;
  activeDotIndex: number;
  onDotClick: (dotIndex: number, event: React.MouseEvent) => void;
  isWhiteActiveDot: boolean;
  dataHook?: string;
}

export const WidgetCarouselDots: React.FC<WidgetCarouselDotsProps> = ({
  dotsCount,
  activeDotIndex,
  onDotClick,
  isWhiteActiveDot,
  dataHook,
}) => (
  <div className={styles.container} data-hook={dataHook}>
    {times(dotsCount, (dotIndex) => {
      const isActive = dotIndex === activeDotIndex;
      return (
        <div
          className={cs(styles.dot, { [styles.activeDot]: isActive, [styles.isWhiteActiveDot]: isWhiteActiveDot })}
          onClick={(event) => onDotClick(dotIndex, event)}
          key={dotIndex}
          data-hook={widgetCarouselDotsDataHooks.dot({ index: dotIndex, isActive })}
        />
      );
    })}
  </div>
);
